import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { routing } from './app.routing';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthenticationService } from './services/authentication.service';
import { AuthGuard } from './guards/auth.guard';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { Env } from './env';
import { AuthInterceptor } from './interceptor/authInterceptor';
import { BaseService } from './base.service';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { DashboardModule } from './dashboard/dashboard.module';
import { AlertModule } from 'ngx-bootstrap/alert';


import { ShowErrorsAppComponent } from './show-errors-app/show-errors-app.component';

// Firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { ContractsService } from './services/contracts.service';
import { PropertyBindingType } from '@angular/compiler';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    ShowErrorsAppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    routing,
    HttpClientModule,
    AngularFontAwesomeModule,
    NoopAnimationsModule,
    DashboardModule,
    AlertModule.forRoot(),
    // Firebase
    AngularFireModule.initializeApp({
      apiKey: environment.apiKey,
      authDomain: environment.authDomain,
      storageBucket: environment.storageBucket,
      projectId: environment.projectId,
      databaseURL: environment.databaseURL,
    }),
    AngularFireStorageModule,
    AngularFireDatabaseModule
    // End firebase
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthenticationService,
    AuthGuard,
    Env,
    BaseService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/app.module.ts